import { db } from "../utils/firebase";
import { collection, getDocs } from "firebase/firestore";
import { useState, useEffect } from "react";
import React from "react";
import { sortByDate } from "../functions/sortByDate";

export default function RecentVotes() {
  const [voteList, setVoteList] = useState([]);

  async function GetProposalId() {
    var proposals = [];
    await getDocs(collection(db, "Proposals")).then((docs) =>
      docs.forEach((doc) => {
        proposals.push(doc.id);
      })
    );
    return proposals;
  }

  useEffect(() => {
    async function testing(prop) {
      const proposals = await prop;
      var votes = [];
      proposals.forEach((prop) => {
        getDocs(collection(db, "Proposals", prop, "Votes")).then((stuff) => {
          stuff.forEach((umm) => {
            votes.push(umm.data());
            setVoteList(votes);
          });
        });
      });
      return voteList;
    }

    testing(GetProposalId());
  }, []);

  return (
    <>
      <div
      className="dashboard_heading"
      >
        <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Name</b>
        <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Community</b>
        <b style={{ flex: 1, margin: "1em 0", fontSize: 22 }}>Stance</b>
      </div>
      {sortByDate(voteList).map((prop, i) => {
        return (
          <div
            key={i}
            className="dashboard_datarow"
          >
            <p style={{ flex: 1, margin: "5px 0" }}>{prop.firstName}</p>

            <p style={{ flex: 1, margin: "5px 0" }}>{prop.community}</p>
            <p style={{ flex: 1, margin: "5px 0" }}>
              {prop.for ? "For" : "Against"}
            </p>
          </div>
        );
      })}
    </>
  );
}

//  export async function GetAllVotes(prop) {
//   console.log(prop);
//   async function task() {
//     var proposals = [];
//     await getDocs(collection(db, "Proposals")).then((docs) =>
//       docs.forEach((doc) => {
//         proposals.push(doc.id);
//       })
//     );
//     return proposals;
//   }

//   async function testing(prop) {
//     const proposals = await prop;
//     proposals.forEach((prop) => {
//       console.log(prop);
//     });
//   }

//   testing(task());

// var votes = [];
// proposals.forEach((prop) => {
//   getDocs(collection(db, "Proposals", prop, "Votes")).then((stuff) => {
//     stuff.forEach((umm) => {
//       votes.push(umm.data());
//       console.log(votes);
//     });
//   });
// });
//   var voteList = [];

//   testing(proposals);

//   return voteList;
// }
